export default __webpack_public_path__ + "3d6b075363958d8ac4c8598dbfec5873.svg";